/**
 * ArticlesByTagPage - Página de listagem de artigos filtrados por tag
 *
 * TRANSFORMER PATTERN:
 * Esta página agora usa ArticleListPageTemplate com filtro por tag.
 * - baseFilter: { tagId } (artigos com tag específica)
 * - pageTitle: "Artigos por Tag"
 * - pageConfig: { showScraping: false, showBackgroundScraping: false, showTagHeader: true }
 *
 * ANTES: 420+ linhas de código (95% duplicado de ArticlePage)
 * DEPOIS: 15 linhas de código
 * BENEFÍCIO: Consistência total com ArticlePage!
 */
import React from 'react';
import { useParams } from 'react-router-dom';
import ArticleListPageTemplate from '../../components/templates/ArticleListPageTemplate/ArticleListPageTemplate';

const ArticlesByTagPage = () => {
  const { tagId } = useParams();

  return (
    <ArticleListPageTemplate
      pageTitle="Artigos por Tag"
      baseFilter={{ tagId }}
      pageConfig={{
        showScraping: false,
        showBackgroundScraping: false,
        showTagHeader: true
      }}
    />
  );
};

export default ArticlesByTagPage;
